import { i18n } from '@fs/zion-locale'

export const internationalLabelString = (): string => i18n.t('phone-number.international.label', 'International')

export const invalidValidationString = (): string =>
  i18n.t('phone-number.invalid.validation', 'Please enter a valid phone number.')

export const locationLabelString = (): string => i18n.t('phone-number.location.label', 'Phone Number Location')

export const mobileLabelString = (): string => i18n.t('phone-number.mobile.label', 'Mobile Number')

export const unsupportedValidationString = (): string =>
  i18n.t('phone-number.unsupported.validation', 'This phone number location is not currently supported.')
